import { useSelector } from 'react-redux';
import ItemsViewer from '../components/Common/ItemsViewer';

const ReportsScreen = () => {
  const slug = 'reports';
  const rootUrl = 'api/directories';
  const section = '';
  const { userInfo, permissions } = useSelector((state) => state.auth);
  const perm = {
    canRead: userInfo?.isAdmin || !!permissions?.reports?.run,
  };

  return (
    <ItemsViewer
      rootUrl={rootUrl}
      section={section}
      slug={slug}
      permissions={perm}
      navigateOptions={{
        itemKey: 'code',
      }}
    />
  );
};

export default ReportsScreen;
